<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="fare-condition-details-title"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01">
      <h1
        id="fare-condition-details-title"
        class="p-modal-head01__title"
        [innerHTML]="'label.fareRulesDetail' | staticMsg"
      ></h1>
      <button
        id="p-fare-condition-details-header-button"
        class="p-modal-head01__close js-modal-close"
        (throttleClick$)="clickClose()"
        aswThrottleClick
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <asw-block-slider id="fare-condition-details-slider">
      <div class="p-modal-body05">
        <div class="slider-frame01" #scrollPanel>
          <div class="p-fare-rule-detail-panel">
            <ng-container *ngFor="let bound of data; index as i">
              <!-- 以下、区間毎に繰り返し -->
              <asw-fare-condition-details-per-bound
                [data]="bound"
                [boundIndex]="i"
                class="p-fare-rule-detail-panel__item"
              ></asw-fare-condition-details-per-bound>
              <!-- ここまで、区間毎に繰り返し -->
            </ng-container>
          </div>
        </div>
      </div>
    </asw-block-slider>
  </div>
</div>
